// Regular expression to match hex color codes with or without alpha
const hexColorRegex = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{4}|[0-9A-Fa-f]{6}|[0-9A-Fa-f]{8})$/;

export function isValidHexColor(hex: string) {
  return hexColorRegex.test(hex);
}
